import React from "react"
import LogoVillaGreco from "../images/logo.png"

const SiteDisabled: React.FC = () => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f8f9fa", // Sfondo chiaro
        color: "#333", // Testo scuro per contrasto
      }}
    >
      {/* Logo Emanuela Greco */}
      {/* <img
        src={process.env.REACT_APP_IMMAGINEEMANUELA}
        alt="Logo Villa Greco"
        style={{
          width: "150px",
          marginBottom: "20px",
          borderRadius: "50%", // Forma circolare per il logo
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Ombra leggera
        }}
      /> */}

      {/* Logo Villa Greco */}
      <img
        src={LogoVillaGreco}
        alt="Logo Villa Greco"
        style={{
          width: "150px",
          marginBottom: "20px",
          borderRadius: "50%", // Forma circolare per il logo
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Ombra leggera
        }}
      />

      {/* Titolo */}
      <h1 style={{ marginBottom: "10px", fontSize: "1.8rem" }}>
        Il sito Villa Greco è momentaneamente disabilitato.
      </h1>

      {/* Messaggio */}
      <p style={{ marginBottom: "20px", fontSize: "1rem" }}>
        Contattaci per maggiori informazioni.
      </p>

      {/* Telefono */}
      <p style={{ marginBottom: "10px" }}>
        Telefono:{" "}
        <a
          href={`tel:${process.env.REACT_APP_WHATSAPP_NUMERO}`}
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          {process.env.REACT_APP_WHATSAPP_NUMERO}
        </a>
      </p>

      {/* Email */}
      <p>
        Email:{" "}
        <a
          href={`mailto:${process.env.REACT_APP_EMAILCONTATTO}`}
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          {process.env.REACT_APP_EMAILCONTATTO}
        </a>
      </p>
    </div>
  )
}

export default SiteDisabled
